import { useQueryClient as useRestClient } from 'react-query';

export default useRestClient;
